import * as t from "io-ts";
import { DateFromISOString } from "io-ts-types/lib/DateFromISOString";

import { OrderStatus, PaymentState } from "../constants";
import { Address } from "./address";
import { FinancingPlan } from "./financing";
import { DineroFromString } from "./utils";

const Order = t.readonly(
    t.type({
        token: t.string,
        number: t.string,
        date_placed: DateFromISOString,
        //
        basket_total_before_discounts_excl_tax: DineroFromString,
        basket_total_before_discounts_incl_tax: DineroFromString,
        //
        basket_total_excl_tax: DineroFromString,
        basket_total_incl_tax: DineroFromString,
        //
        shipping_excl_tax: DineroFromString,
        shipping_incl_tax: DineroFromString,
        //
        total_excl_tax: DineroFromString,
        total_incl_tax: DineroFromString,
    }),
);

export type IOrder = t.TypeOf<typeof Order>;

export const CompleteOrderPaymentInitData = t.readonly(
    t.type({
        basket: t.readonly(
            t.type({
                token: t.string,
            }),
        ),
        order: Order,
        financing_plans: t.readonlyArray(FinancingPlan),
        shipping_address: Address,
        billing_address: Address,
    }),
);

// Payment method types
type IPaymentMethod = Readonly<{
    enabled: boolean;
    pay_balance: boolean;
}>;

export type IPayment = Readonly<{
    "cash"?: IPaymentMethod;
    "pay-later"?: IPaymentMethod;
    "cybersource-microform"?: IPaymentMethod &
        Readonly<{
            transient_token: string;
        }>;
    "financing"?: IPaymentMethod &
        Readonly<{
            account_number: string;
            financing_plan: number;
        }>;
}>;

export type IOrderResponse = Readonly<{
    number: string;
    status: string;
    [propName: string]: string;
}>;

export type IPaymentRejectMsgs = Readonly<{
    "cybersource-microform": string;
    "financing": string;
    "cash": string;
    "pay-later": string;
    [key: string]: string;
}>;

type IPaymentState = Readonly<{
    status: PaymentState;
    amount: string;
}>;

export type IPaymentStates = Readonly<{
    order_status: OrderStatus;
    payment_method_states: Readonly<{
        [code: string]: IPaymentState;
    }>;
}>;
